import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import { formatDate } from "@/lib/date-utils"
import type { BreadcrumbItem } from "@/types"

interface Vendor {
  id: number
  display_name: string
}

interface Log {
  id: number
  log_date: string | null
  notes: string | null
  contact_name: string | null
  created_by: string | null
  created_at: string
}

interface Props {
  vendor: Vendor
  logs: Log[]
}

export default function Index({ vendor, logs }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Subcontractors", href: "/company/vendors" },
    { title: vendor.display_name, href: `/company/vendors/${vendor.id}` },
    { title: "Logs", href: `/company/vendors/${vendor.id}/logs` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${vendor.display_name} - Logs`} />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">
            Activity Log for {vendor.display_name}
          </h1>
          <Link
            href={`/company/vendors/${vendor.id}/logs/new`}
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Log Entry
          </Link>
        </div>

        {logs.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Date
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Contact
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Notes
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Created By
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/company/vendors/${vendor.id}/logs/${log.id}`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      {formatDate(log.log_date)}
                    </Link>
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {log.contact_name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {log.notes}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {log.created_by}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/company/vendors/${vendor.id}/logs/${log.id}/edit`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No log entries found.</p>
        )}
      </div>
    </AppLayout>
  )
}
